module.exports = "/_next/static/images/a8966cf913f9f033023451dc1d6fe463-choose-money-box.gif.webp";